import React from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import AppRouter from "./AppRouter.tsx";
import './App.css';

const Main = () => {
  const [outerRoute, setOuterRoute] = React.useState<string|undefined>(undefined);

  return (
    <Auth0Provider
      domain="zebrain.eu.auth0.com"
      clientId="gL2YmT08MGR5YvIMUQOTx1LHwfwHArna"
      authorizationParams={{
        audience: 'https://zebrain.eu.auth0.com/api/v2/',
        redirect_uri: window.location.origin,
      }}
      onRedirectCallback={
        (appState) => {
          console.log("appState", appState);
          if (appState) {
            setOuterRoute(appState.returnTo);
          }
        }
      }
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <AppRouter outerRoute={outerRoute} />
    </Auth0Provider>
  )
}

let container = document.getElementById("app")!;
let root = createRoot(container)
root.render(
  <Main />
);


